import { WritableSignal, computed, signal } from "@angular/core";

import { IBanner, IBannerDetails } from "./BannerTypes";

export class BannerHelper {
	public bannerDetails: WritableSignal<IBannerDetails> = signal({ isEnabled: false, banners: [] });
	public closedBannerIds: WritableSignal<string[]> = signal([]);

	public readonly isAnyBannerVisible = computed(() =>
		this.bannerDetails().banners.some(banner => banner.isEnabled && banner.pushMethod === 'Manual' && this.closedBannerIds().indexOf(banner.id) === -1)
	);

	constructor(
		banners: IBannerDetails
	) {
		this.setBannerDetails(banners);
	}

	public setBannerDetails(bannerDetails: IBannerDetails): void {
		this.bannerDetails.set(bannerDetails);
	}

	public updateBannerDetails(newBannerDetails: IBannerDetails): void {
		this.closedBannerIds.set(this.closedBannerIds().filter(id => newBannerDetails.banners.find((banner) => banner.id === id)?.isEnabled));
		this.bannerDetails.set(newBannerDetails);
	}

	public closeBanner(selectedBanner: IBanner): void {
		this.closedBannerIds.set([...this.closedBannerIds(), selectedBanner.id]);
	}

}
